module.exports = __webpack_public_path__ + "img/project-langhamplace.28fd5903.jpg";